import React, { useState } from 'react';
import Navbar from '../Navbar';
import Sidebar from '../Sidebar';
import Footer from '../Footer';
import {
  PageContainer,
  MainSection,
  BackLink,
  IntroSection,
  IntroPhotoWrap,
  IntroPhoto,
  IntroPhotoPlaceholder,
  IntroContent,
  PageHeading,
  IntroSubheading,
  PageSubtext,
  SectionTitle,
  BrandsSection,
  BrandsGrid,
  BrandLogoLink,
  BrandLogoCircle,
  BrandLogoImg,
  BrandLogoPlaceholder,
  LinkedInSection,
  LinkedInList,
  LinkedInBtn,
  GallerySection,
  GalleryGrid,
  GalleryItem,
  GalleryImg,
  GalleryPlaceholder,
} from './HaleyPageElements';
import {
  HELI_PHOTO,
  HELI_LINKEDIN_URL,
  BRANDS,
  BRANDS_LOGO_BASE,
  GALLERY_IMAGES,
} from './HaleysData';

const HaleyPage = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [photoError, setPhotoError] = useState(false);
  const [logoErrors, setLogoErrors] = useState({});
  const toggle = () => setIsOpen(!isOpen);

  const galleryBase = process.env.PUBLIC_URL + '/haleys-gallery/';
  const linkedInProfiles = HELI_LINKEDIN_URL
    ? [{ label: "Heli's Instagram", url: HELI_LINKEDIN_URL }]
    : [];

  return (
    <>
      <Sidebar isOpen={isOpen} toggle={toggle} />
      <Navbar toggle={toggle} />
      <PageContainer>
        <MainSection>
          <BackLink to="/service/social-media">← Back to Social Media</BackLink>

          {/* Intro: Heli + photo + what she does */}
          <IntroSection>
            <IntroPhotoWrap>
              {!photoError ? (
                <IntroPhoto
                  src={HELI_PHOTO}
                  alt="Heli, social media expert and co-founder of the Wiry"
                  onError={() => setPhotoError(true)}
                />
              ) : (
                <IntroPhotoPlaceholder>
                  Add heli-portfolio.png to the public folder
                </IntroPhotoPlaceholder>
              )}
            </IntroPhotoWrap>
            <IntroContent>
              <PageHeading>Heli</PageHeading>
              <IntroSubheading>
                Social media expert & co-founder of the Wiry
              </IntroSubheading>
              <PageSubtext>
                Heli leads our social media work and has worked with a wide range of brands
                across strategy, content, and community. She manages social media projects
                from concept to execution and helps businesses grow and connect with their
                audiences.
              </PageSubtext>
            </IntroContent>
          </IntroSection>

          {/* Brands — logos (upload to public/heli-brands/), clickable to socialUrl */}
          <BrandsSection>
            <SectionTitle>Brands she works with</SectionTitle>
            <BrandsGrid>
              {BRANDS.map((brand) => {
                const logoUrl = BRANDS_LOGO_BASE + brand.logo;
                const showPlaceholder = logoErrors[brand.name];
                const content = (
                  <BrandLogoCircle>
                    {showPlaceholder ? (
                      <BrandLogoPlaceholder>{brand.name}</BrandLogoPlaceholder>
                    ) : (
                      <BrandLogoImg
                        src={logoUrl}
                        alt={brand.name}
                        onError={() => setLogoErrors((prev) => ({ ...prev, [brand.name]: true }))}
                      />
                    )}
                  </BrandLogoCircle>
                );
                return brand.socialUrl ? (
                  <BrandLogoLink
                    key={brand.name}
                    href={brand.socialUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    title={`${brand.name} — social`}
                  >
                    {content}
                  </BrandLogoLink>
                ) : (
                  <span key={brand.name} style={{ display: 'flex', alignItems: 'center' }}>
                    {content}
                  </span>
                );
              })}
            </BrandsGrid>
          </BrandsSection>

          {/* LinkedIn */}
          <LinkedInSection>
            <SectionTitle>Connect on Instagram</SectionTitle>
            {linkedInProfiles.length > 0 ? (
              <LinkedInList>
                {linkedInProfiles.map(({ label, url }) => (
                  <LinkedInBtn
                    key={label}
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {label}
                  </LinkedInBtn>
                ))}
              </LinkedInList>
            ) : (
              <PageSubtext style={{ marginBottom: 0 }}>
                Add LinkedIn URLs in <code>src/components/HaleyPage/HaleysData.js</code> (Heli
                and brands) to show profile links here.
              </PageSubtext>
            )}
          </LinkedInSection>

          {/* Gallery */}
          <GallerySection>
            <SectionTitle>Portfolio gallery</SectionTitle>
            {GALLERY_IMAGES.length > 0 ? (
              <GalleryGrid>
                {GALLERY_IMAGES.map((filename, i) => (
                  <GalleryItem key={i}>
                    <GalleryImg
                      src={galleryBase + filename}
                      alt={`Portfolio ${i + 1}`}
                    />
                  </GalleryItem>
                ))}
              </GalleryGrid>
            ) : (
              <>
                <PageSubtext style={{ marginBottom: 24 }}>
                  Add images to <code>public/haleys-gallery/</code> and list filenames in{' '}
                  <code>HaleysData.js</code> (GALLERY_IMAGES) to display the gallery.
                </PageSubtext>
                <GalleryGrid>
                  {[1, 2, 3].map((n) => (
                    <GalleryItem key={n}>
                      <GalleryPlaceholder>Portfolio image {n}</GalleryPlaceholder>
                    </GalleryItem>
                  ))}
                </GalleryGrid>
              </>
            )}
          </GallerySection>
        </MainSection>
      </PageContainer>
      <Footer />
    </>
  );
};

export default HaleyPage;
